import React from 'react';
import { fetchLocalizingListNew } from 'apis/common/commonApis';

/**
 *
 * @returns {다국어 항목 출력 hook}
 */
const fetchLocalizingInput = async (langList, setLangList) => {
  const resLangList = await fetchLocalizingListNew();

  let keyArr = [];

  const newLocalArr = [];
  if (langList && resLangList) {
    resLangList?.forEach((v) => {
      langList.forEach((item) => {
        if (v.code === item.lang) {
          item.code_name = v.code_name;
        }

        keyArr = Object.keys(item);
      });
    });

    resLangList?.forEach((v, i) => {
      const newObject = {};

      for (let i = 0; i < keyArr.length; i++) {
        newObject[keyArr[i]] = '';
      }
      newObject.key = i;
      newObject.lang = v.code;
      newObject.code_name = v.code_name;
      newObject.category_thumbnail_id = -1;
      newObject.circle_image_id = -1;
      newObject.ifyou_banner_id = -1;
      newObject.introduce_image_id = -1;
      newObject.banner_id = -1;
      newLocalArr.push(newObject);
    });

    newLocalArr?.forEach((v, i) => {
      langList?.forEach((val, idx) => {
        if (v.lang?.indexOf(val?.lang) !== -1) {
          Object.assign(v, val);
        }
      });
    });
    setLangList(newLocalArr);
  }

  return <></>;
};

export default fetchLocalizingInput;
